import { render, staticRenderFns } from "./_year.vue?vue&type=template&id=155095e0&"
import script from "./_year.vue?vue&type=script&lang=js&"
export * from "./_year.vue?vue&type=script&lang=js&"
import style0 from "./_year.vue?vue&type=style&index=0&id=155095e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports